import { createFileRoute } from "@tanstack/react-router";
import Annex1ResourceCenter from "@/pages/Annex1ResourceCenter";

const title = "Centro de Recursos del Anexo 1 | QbD Group";
const description =
  "Orientación práctica sobre el Anexo 1 de las GMP de la UE: artículos, webinars, herramientas y análisis de expertos sobre control de la contaminación, salas blancas, personal y suministros.";
const image = "https://jrtdedcfhvzaomneervp.supabase.co/storage/v1/object/public/webinar-images/annex1-webinar-featured-tablet.png";

export const Route = createFileRoute("/es/centro-recursos-anexo-1")({
  head: () => ({
    meta: [
      { title },
      { name: "description", content: description },
      { property: "og:title", content: title },
      { property: "og:description", content: description },
      { property: "og:type", content: "website" },
      { property: "og:locale", content: "es_ES" },
      { property: "og:image", content: image },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:image", content: image },
    ],
    links: [{ rel: "canonical", href: "https://qbdgroup.com/es/centro-recursos-anexo-1" }],
  }),
  component: () => <Annex1ResourceCenter lang="es" />,
});
